<template>
  <v-container fluid>
    <v-card
      width="256"
      class="mx-auto rounded-lg"
    >
      <v-navigation-drawer>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              Admin panel
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider/>
        <v-list-item
          to="/admin/platforms"
        >
          <v-list-item-content>
            <v-list-item-title>
              Platforms
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          :value="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Map Settings</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="page in mapPages" >
            <v-list-group
              v-if="page.children"
              :value="false"
              :key="page.title"
              class="pl-4"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ page.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="subpage in page.children"
                :key="subpage.title"
                :to="subpage.link"
                link
                class="pl-8"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subpage.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="page.title + ' link'"
              :to="page.link"
              link
              class="pl-8"
            >
              <v-list-item-content>
                <v-list-item-title>{{ page.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
        <v-list-group
          :value="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Telemetry Settings</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="page in telemetryPages" >
            <v-list-group
              v-if="page.children"
              :value="false"
              :key="page.title"
              class="pl-8"
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ page.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="subpage in page.children"
                :key="subpage.title"
                :to="subpage.link"
                link
                class="pl-8"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subpage.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="page.title + ' link'"
              :to="page.link"
              link
              class="pl-8"
            >
              <v-list-item-content>
                <v-list-item-title>{{ page.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
        <v-list-group
          :value="false"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Multi project Settings</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-for="page in multiprojectPages" >
            <v-list-group
              v-if="page.children"
              :value="false"
              :key="page.title"
              class="pl-8"
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ page.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="subpage in page.children"
                :key="subpage.title"
                :to="subpage.link"
                link
                class="pl-8"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ subpage.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="page.title + ' link'"
              :to="page.link"
              link
              class="pl-8"
            >
              <v-list-item-content>
                <v-list-item-title>{{ page.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-group>
        <v-list-item
          to="/admin/levels-references"
        >
          <v-list-item-content>
            <v-list-item-title>
              Levels References
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          to="/admin/engine-api"
        >
          <v-list-item-content>
            <v-list-item-title>
              Engine API
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      mapPages: [
        { title: 'Global', link: '/admin/map/global' },
        { title: 'Runtime',
          children: [
            { title: 'Global', link: '/admin/map/runtime/global' },
            { title: 'Custom', link: '/admin/map/runtime/custom' },
            { title: 'LLM Stats Categories', link: '/admin/map/runtime/llm-stats-categories' }
          ]
        },
        { title: 'Editor', link: '/admin/map/editor' },
        { title: 'Segments', link: '/admin/map/segments' }
      ],
      telemetryPages: [
        { title: 'Timeline', link: '/admin/telemetry/timeline' },
        { title: 'Heatmap', link: '/admin/telemetry/heatmap' },
        { title: 'Recalculation', link: '/admin/telemetry/recalculation' },
        { title: 'Sessions', link: '/admin/telemetry/sessions' },
        { title: 'Feedback actions', link: '/admin/telemetry/feedback-actions' },
        { title: 'Encounters', link: '/admin/telemetry/encounters' },
        { title: 'Difficulty Levels', link: '/admin/telemetry/difficulty-levels' }
      ],
      multiprojectPages: [
        { title: 'Platforms', link: '/admin/multiproject/platforms' },
        { title: 'Projects', link: '/admin/multiproject/projects' }
      ]
    }
  }
}
</script>